import axios from 'axios';

const setToken = (token) => {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

// Only fall back to localhost when the var is unset (dev with no .env). An
// explicit empty value (production/stage) means "same-origin / relative".
const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL;
const dev = (configuredBaseUrl == null ? 'https://localhost:5011' : configuredBaseUrl).replace(/\/$/, '');

const baseURL = () => {
    axios.defaults.baseURL = dev;
};

export { baseURL };
export default setToken;
